import React from 'react';
import MarketingLayout from '../components/MarketingLayout';
import { Link } from 'react-router-dom';

const h2Style = {fontSize: '1.75rem', color: '#111827', marginTop: '3rem', marginBottom: '1.25rem', fontWeight: '700', paddingBottom: '0.5rem', borderBottom: '2px solid #dc2626'};
const h3Style = {fontSize: '1.2rem', color: '#111827', marginTop: '1.5rem', marginBottom: '0.75rem', fontWeight: '600'};
const pStyle = {marginBottom: '1rem', color: '#374151', lineHeight: '1.8'};
const ulStyle = {marginLeft: '2rem', marginBottom: '1.5rem'};
const liStyle = {marginBottom: '0.75rem', color: '#374151', lineHeight: '1.7'};

const PrivacyPage = () => {
  return (
    <MarketingLayout>
      {/* Hero Section */}
      <section className="terms-hero" style={{background: '#dc2626', backgroundColor: '#dc2626', paddingTop: '166px', paddingBottom: '80px', paddingLeft: '20px', paddingRight: '20px', textAlign: 'center', marginTop: '-86px'}}>
        <div className="container">
          <h1 style={{fontSize: '3rem', color: 'white', marginBottom: '1rem', fontWeight: '700'}}>Privacy Policy</h1>
          <p style={{fontSize: '1.1rem', color: 'rgba(255, 255, 255, 0.9)'}}>Last Updated: November 2025</p>
        </div>
      </section>

      {/* Privacy Content */}
      <div className="terms-container" style={{maxWidth: '1200px', margin: '0 auto', padding: '80px 100px', background: 'white'}}>
        <Link to="/" style={{display: 'inline-flex', alignItems: 'center', color: '#dc2626', textDecoration: 'none', fontWeight: '600', marginBottom: '2rem'}}>← Back to Home</Link>

        <div style={{padding: '0 60px'}}>
          <div style={{background: '#f8f9fa', padding: '25px 30px', borderRadius: '0', marginBottom: '40px', border: 'none', borderLeft: '4px solid #dc2626'}}>
            <p style={{marginBottom: '0.5rem', color: '#374151', fontSize: '0.95rem'}}><strong>Effective Date:</strong> 11 November 2025</p>
            <p style={{marginBottom: '0.5rem', color: '#374151', fontSize: '0.95rem'}}><strong>Owned and operated by:</strong> Castleview Resources Ltd, Company No. 760626, Ireland.</p>
            <p style={{marginBottom: '0', color: '#374151', fontSize: '0.95rem'}}><strong>Email:</strong> info@playbacktoken.com</p>
          </div>

          <h2 style={h2Style}>1. Purpose</h2>
          <p style={pStyle}>
            This Privacy Policy explains how PlayBack Token ("we", "our", "us") collects, uses, stores, and protects your personal data when you use our website, web application, or related services (together, "the Platform").
          </p>
          <p style={pStyle}>
            We are committed to protecting your privacy and handling your data transparently and lawfully in accordance with EU GDPR, the Irish Data Protection Act 2018, and relevant international data protection laws.
          </p>

          <h2 style={h2Style}>2. Data Controller</h2>
          <p style={pStyle}>
            PlayBack Token is owned and operated by Castleview Resources Ltd, registered in Ireland (Company No. 760626). Castleview Resources Ltd acts as the Data Controller for all personal data collected via the Platform.
          </p>
          <p style={pStyle}>
            In some cases, our payment processor Stripe or other third-party providers may act as Data Processors or Joint Controllers under applicable laws.
          </p>

          <h2 style={h2Style}>3. Data We Collect</h2>
          <p style={pStyle}>We collect only the information necessary to provide and improve our services. Depending on how you use the Platform, we may collect:</p>
          
          <h3 style={h3Style}>a. From Clubs</h3>
          <ul style={ulStyle}>
            <li style={liStyle}>Club name, address, registration details</li>
            <li style={liStyle}>Contact person's name, email, and phone number</li>
            <li style={liStyle}>Bank account details (for fund transfers)</li>
            <li style={liStyle}>Volunteer hour logs and related metadata</li>
            <li style={liStyle}>Audit and verification documentation</li>
          </ul>

          <h3 style={h3Style}>b. From Companies or Supporters</h3>
          <ul style={ulStyle}>
            <li style={liStyle}>Name, organization, and contact details</li>
            <li style={liStyle}>Billing address and payment details (processed by Stripe)</li>
            <li style={liStyle}>Purchase history and transaction records</li>
          </ul>

          <h3 style={h3Style}>c. From All Users</h3>
          <ul style={ulStyle}>
            <li style={liStyle}>Account login credentials (email and encrypted password)</li>
            <li style={liStyle}>Browser, IP address, and device identifiers</li>
            <li style={liStyle}>Communications and correspondence with us</li>
          </ul>

          <p style={pStyle}>We do not collect sensitive personal data (such as health, race, religion, or political beliefs).</p>

          <h2 style={h2Style}>4. How We Use Your Data</h2>
          <p style={pStyle}>We process personal data to:</p>
          <ul style={ulStyle}>
            <li style={liStyle}>Verify Club eligibility and manage account access</li>
            <li style={liStyle}>Facilitate payments and transfers through Stripe</li>
            <li style={liStyle}>Generate receipts, invoices, and financial records</li>
            <li style={liStyle}>Issue and verify digital soulbound tokens</li>
            <li style={liStyle}>Conduct audits and fraud prevention checks</li>
            <li style={liStyle}>Communicate updates, support, and compliance notices</li>
            <li style={liStyle}>Improve and secure the Platform's functionality</li>
            <li style={liStyle}>Comply with legal and regulatory obligations</li>
          </ul>

          <h2 style={h2Style}>5. Lawful Basis for Processing</h2>
          <p style={pStyle}>We process personal data under one or more of the following lawful bases:</p>
          <ul style={ulStyle}>
            <li style={liStyle}><strong>Contractual necessity:</strong> to provide the Platform and process payments</li>
            <li style={liStyle}><strong>Legitimate interests:</strong> to verify Clubs and prevent fraud</li>
            <li style={liStyle}><strong>Legal obligation:</strong> to comply with tax, accounting, and anti-fraud regulations</li>
            <li style={liStyle}><strong>Consent:</strong> for optional communications such as newsletters or updates</li>
          </ul>
          <p style={pStyle}>You may withdraw consent for non-essential processing at any time by contacting us.</p>

          <h2 style={h2Style}>6. Data Sharing</h2>
          <p style={pStyle}>We share data only when necessary and with trusted third parties who comply with GDPR-level safeguards, including:</p>
          <ul style={ulStyle}>
            <li style={liStyle}>Stripe Payments Europe Ltd (payment processing)</li>
            <li style={liStyle}>Auditors or compliance partners (for Club verification)</li>
            <li style={liStyle}>IT and hosting providers (secure infrastructure management)</li>
            <li style={liStyle}>Law enforcement or regulators, where legally required</li>
          </ul>
          <p style={pStyle}>We never sell or rent your personal data.</p>

          <h2 style={h2Style}>7. International Data Transfers</h2>
          <p style={pStyle}>
            As we operate globally, data may be transferred outside the European Economic Area (EEA). When this occurs, we ensure appropriate safeguards such as:
          </p>
          <ul style={ulStyle}>
            <li style={liStyle}>Standard Contractual Clauses (SCCs) approved by the European Commission; or</li>
            <li style={liStyle}>Transfers to jurisdictions with adequacy decisions (e.g., UK, Canada).</li>
          </ul>
          <p style={pStyle}>All partners are required to maintain GDPR-equivalent protection.</p>

          <h2 style={h2Style}>8. Data Retention</h2>
          <p style={pStyle}>We retain personal data only for as long as necessary to fulfil the purposes above:</p>
          <ul style={ulStyle}>
            <li style={liStyle}><strong>Club and transaction data:</strong> 7 years (for legal and accounting compliance)</li>
            <li style={liStyle}><strong>User accounts:</strong> active until deletion or inactivity for 24 months</li>
            <li style={liStyle}><strong>Audit and verification records:</strong> as required by law</li>
          </ul>
          <p style={pStyle}>After the retention period, data is securely deleted or anonymized.</p>

          <h2 style={h2Style}>9. Data Security</h2>
          <p style={pStyle}>We use technical and organizational measures to safeguard your information, including:</p>
          <ul style={ulStyle}>
            <li style={liStyle}>Encryption (TLS) for all data in transit</li>
            <li style={liStyle}>Hashed and salted passwords</li>
            <li style={liStyle}>Role-based access controls</li>
            <li style={liStyle}>Regular security testing and monitoring</li>
          </ul>
          <p style={pStyle}>No online system is entirely risk-free, but we take all reasonable steps to protect your data.</p>

          <h2 style={h2Style}>10. Your Rights</h2>
          <p style={pStyle}>Under the EU GDPR and Irish Data Protection Act, you have the right to:</p>
          <ul style={ulStyle}>
            <li style={liStyle}>Access a copy of your personal data</li>
            <li style={liStyle}>Request correction of inaccurate information</li>
            <li style={liStyle}>Request deletion ("right to be forgotten")</li>
            <li style={liStyle}>Restrict or object to certain processing</li>
            <li style={liStyle}>Data portability (to another service provider)</li>
            <li style={liStyle}>Withdraw consent at any time</li>
          </ul>
          <p style={pStyle}>
            Requests can be sent to <a href="mailto:info@playbacktoken.com" style={{color: '#dc2626', textDecoration: 'underline'}}>info@playbacktoken.com</a>, and we will respond within 30 days.
          </p>
          <p style={pStyle}>
            If you are unsatisfied, you may lodge a complaint with the Irish Data Protection Commission at <a href="https://www.dataprotection.ie" target="_blank" rel="noopener noreferrer" style={{color: '#dc2626', textDecoration: 'underline'}}>www.dataprotection.ie</a>.
          </p>

          <h2 style={h2Style}>11. Cookies and Tracking</h2>
          <p style={pStyle}>
            Our website uses essential cookies for functionality and analytical cookies to improve user experience. You can manage or disable cookies via your browser settings.
          </p>
          <p style={pStyle}>We do not use third-party tracking for advertising or profiling purposes.</p>

          <h2 style={h2Style}>12. Children's Data</h2>
          <p style={pStyle}>
            Our Platform is not intended for individuals under 16 years of age. We do not knowingly collect data from minors. Clubs submitting youth participation data must ensure it is anonymized or consent is obtained from parents/guardians.
          </p>

          <h2 style={h2Style}>13. Updates to This Policy</h2>
          <p style={pStyle}>
            We may update this Privacy Policy periodically to reflect legal or operational changes. The updated version will be published on our website with the revised effective date.
          </p>
          <p style={pStyle}>Continued use of the Platform after changes implies acceptance.</p>

          <h2 style={h2Style}>14. Contact Us</h2>
          <div style={{background: '#f8f9fa', padding: '25px 30px', borderRadius: '0', marginBottom: '40px', border: 'none', borderLeft: '4px solid #dc2626'}}>
            <p style={{marginBottom: '0.5rem', color: '#374151', fontSize: '0.95rem'}}><strong>Castleview Resources Ltd</strong></p>
            <p style={{marginBottom: '0.5rem', color: '#374151', fontSize: '0.95rem'}}>Registered in Ireland</p>
            <p style={{marginBottom: '0.5rem', color: '#374151', fontSize: '0.95rem'}}>Company No. 760626</p>
            <p style={{marginBottom: '0.5rem', color: '#374151', fontSize: '0.95rem'}}>Email: info@playbacktoken.com</p>
            <p style={{marginBottom: '0', color: '#374151', fontSize: '0.95rem'}}>Website: www.playbacktoken.com</p>
          </div>

          <div style={{height: '2px', background: 'linear-gradient(to right, transparent, #d1d5db, transparent)', margin: '3rem 0 2rem 0'}}></div>
          <p style={{textAlign: 'center', color: '#4b5563', fontSize: '0.9rem'}}>© 2025 Castleview Resources Ltd. All rights reserved.</p>
        </div>
      </div>
    </MarketingLayout>
  );
};

export default PrivacyPage;
